export default {
  headerContent: {
    title: 'Türkiye Sigorta Nakliyat Sigortası Fiyatları',
    slogan: "Nakliyat Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'NAKLİYAT SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türkiye Sigorta Nakliyat (Emtea) Sigortası Nedir?',
    description: {
      title: 'Türkiye Sigorta Seyahat Sağlık Sigortası Nedir? ',
      content: [
        'Her ne kadar profesyonel olsak dahi bazen dalgınlık bazen ise dış etkenlerden dolayı hasara uğrayabiliyoruz.',
        'Türkiye Sigorta nakliyat sigortası, taşıma esnasında emteanın uğrayabileceği zararlara karşı koruma sağlayarak sigortalıya finansal güvence sunmaktadır.'
      ]
    },
    subContent: {
      title: 'Türkiye Sigorta Nakliyat Sigortası Türleri Nedir?',
      content: [
        {
          paragraph:
            'Nakliyat sigortasında düzenlenmekte olan 4 adet poliçe çeşidi bulunmaktadır.',
          subList: [
            'Kati Poliçe',
            'Flotan Poliçe(Geçici)',
            'Abonman Poliçe',
            'Blok Poliçe'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Nakliyat Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Nakliyat Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Nakliyat Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Nakliyat Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türkiye Sigorta Nakliyat Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Kati Poliçe Nedir?',
      content: [
        {
          paragraph:
            'Kati poliçe, sevkiyata ait araç bilgileri, sefer tarihi, emtea bedeli ve sevk başlangıç ve bitiş yerinin belirli olduğu takdirde düzenlenen poliçedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Flotan Poliçe Nedir?',
      content: [
        {
          paragraph:
            'Flotan diğer adıyla geçici poliçe, araç bilgileri, sefer tarihi, emtea bedeli ve sevk başlangıç ve bitiş yerinin belirli olmadığı durumlarda düzenlenen poliçedir. Sevk bilgileri netlik kazandığı zamanda kati poliçe düzenlenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Abonman Poliçe Nedir?',
      content: [
        {
          paragraph:
            'Abonman poliçe, bir yıl içerisinde yapılacak olan tüm sevkiyatları için uygulanacak fiyat ve şartları, tarafların yükümlülüklerinin bulunduğu poliçedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Blok Poliçe Nedir?',
      content: [
        {
          paragraph:
            'Blok poliçe, sigortalının 1 yıl içerinde taşıyacağı emteanın bedeli üzerinden düzenlenen poliçedir. 1 yıl içerinde yapacağı sevkiyatlar poliçe başlangıcında belirlenmiş olan sigorta bedeline kadar güvence altındadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Nakliyat Sigortası Teminatları Nedir?',
      content: [
        {
          paragraph: 'Nakliyat sigortasında 3 adet teminat bulunmaktadır. Bu teminatlar;',
          subList: null
        },
        {
          paragraph: 'Ana taminatlar;',
          subList: ['Tam Ziya', 'Dar Teminat', 'Geniş Teminat']
        },
        {
          paragraph: 'Tam Ziya Teminatı Nedir?',
          subList: null
        },
        {
          paragraph:
            'Taşıma aracı ve malın tüm değerini kaybedecek derece hasar görmesini halinde karşılık verilen teminattır.',
          subList: null
        },
        {
          paragraph: 'Dar Teminat Nedir?',
          subList: null
        },
        {
          paragraph:
            'Dar teminat malın ve taşıma aracının uğrayacağı kısmı hasarlar sonucu çıkan masrafları teminat altına almaktadır.',
          subList: null
        },
        {
          paragraph: 'Geniş Teminat Nedir?',
          subList: null
        },
        {
          paragraph:
            'Geniş teminat ile taşınan malda taşıma esnasında oluşacak kaza veya olay neticesindeki maddi kayıplara karşı güvence sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Nakliyat Poliçesi Düzenlenirken Talep Edilen Bilgiler Nelerdir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Firma ise vergi kimlik numarası, şahıs ise t.c. Kimlik numarası.',
            'Sevk başlangıç ve bitiş noktası.',
            'Sevk başlangıç ve bitiş tarihleri.',
            'Sevki gerçekleştirecek araç bilgileri.',
            'Emtea türü.',
            'Emtea bedeli.'
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Nakliyat Poliçesi Hasar Anında Talep Edilen Belge/Bilgiler Nelerdir?',
      content: [
        {
          paragraph:
            'Hasar anında istenen bilgi ve belgeler hasar boyutuna göre değişmektedir.',
          subList: null
        },
        {
          paragraph: 'Genel olarak aşağıdaki bilgi ve belgeler istenmektedir.',
          subList: [
            'Poliçe numarası',
            'Hasar tarihi',
            'Tahmini hasar miktarı',
            'Sigortalının veya irtibat kurulacak kişinin iletişim bilgisi'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta’dan Neden Nakliyat Sigortası Almalıyım?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası taşınan yükün karşılaşabileceği risklere karşı güvence sağlamaktadır. Nakliyat sigortası almanız sizi bu risklerin oluşması sonucunda oluşacak büyük çaplı maddi kayıpları önlemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Nakliyat Sigortası Yaptırmak Zorunlu Mudur?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası zorunlu bir sigorta değildir. İsteğe bağlı olarak yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Nakliyat Sigortası Kim Tarafından Yaptırılır?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası emteanın satıcısı, alıcısı veya yükü taşıyan bu sigortayı yaptırabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Nakliyat Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Nakliyat sigortası fiyatları nakliye türüne, emteanın değerline ve sevkiyat başlangıç bitiş konumuna göre farklılıklar göstermektedir. Bu nedenle net bir nakliyat sigortası fiyatı söylenememektedir.',
          subList: null
        },
        {
          paragraph:
            'Türkiye sigorta nakliyat sigortası primlerin hakkında bilgi almak için nakliyat sigortası başvuru formunu doldurmanız yeterlidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Nakliyat Sigortası Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph: 'Nakliyat sigortası, gelişen ve değişen cağ ile acenteye gitmeye gerek kalmadan online olarak dakikalar içinde hızlı ve kolay bir şekilde alınabilmektedir.',
          subList: null
        },
        {
          paragraph: 'Türkiye Sigorta nakliyat sigortasını online olarak almak için başvuru formunu doldurmanız yeterlidir. Nakliyat sigortası hakkında merak ettikleriniz ve sormak istedikleriniz için çağrı merkezimizle iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
